module.exports = __webpack_public_path__ + "static/img/Boss_31086.6b7454c2.png";